// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-027e965a]{margin-bottom:20px}main[data-v-027e965a]{padding:20px}@media (min-width:60em){main[data-v-027e965a]{display:flex;flex-direction:column;align-items:center}}article[data-v-027e965a]{text-align:justify}@media (min-width:60em){article[data-v-027e965a]{padding:0 11rem;text-align:center}}.underline[data-v-027e965a]{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
